export class CookieUtils {
    public static getCookie(key: string): string | null {
        return document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)")?.pop() ?? null;
    }

    public static setCookie(key: string, value: string, expirationDate: Date): void {
        document.cookie = `${key}=${value};expires=${expirationDate.toUTCString()};path=/`;
    }
}
